import { Box, Chip, CircularProgress, Divider, Link, Paper, Typography } from "@mui/material";
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import changeColorAnimation from "../../colorAnimation";
import HighlightedText from "../../../../../components/HighlightSearch";
import { TFiltrosTarefas } from "../../..";
import { useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { generateLabelInfo } from "../helper";

export default function Feita({
  keyword,
  filtros,
  onClickDetalheProcesso,
  codigoPreenchido,
}: FeitaProps) {

  const tableContainerRef = useRef<HTMLDivElement>(null)
  const [limit, setLimit] = useState<number>(15)

  const { data: pesquisarProcessos, isFetching } = useQuery({
    queryKey: ["pesquisar-processos-finalizados", keyword, filtros, limit],
    queryFn: () =>
      axiosClient.get("/pesquisar-processos", {
        params: {
          situacao: ["Finalizado"],
          limit: limit,
          pesquisar: keyword,
          ...(filtros && {
            fluxo_contem: filtros.fluxo_contem?.map((item) => item.id) ?? null
          }),
        },
      }),
    cacheTime: 0,
  });

  return (
    <Box component={Paper} height="100%">
      <Box display="flex" justifyContent="space-between" padding={2}>
        <Typography variant="h6">Finalizado</Typography>
        {pesquisarProcessos && (
          <Chip
            size="small"
            label={pesquisarProcessos.data.total}
            color="success"
          />
        )}
      </Box>

      <Divider />

      {isFetching && (
        <Box display="flex" justifyContent="center" my={2}>
          <CircularProgress />
        </Box>
      )}

      <Box maxHeight={550} overflow="auto">
        {pesquisarProcessos &&
          <InfiniteScroll
            height={550}
            dataLength={pesquisarProcessos.data.data.length}
            next={() => { setLimit(prev => prev + 15) }}
            hasMore={pesquisarProcessos.data.data.length < pesquisarProcessos.data.total}
            loader={
              <Box display="flex" justifyContent="center" my={2}>
                <CircularProgress size={24} />
              </Box>
            }
            scrollThreshold={0.98}
            scrollableTarget={tableContainerRef.current?.id}
          >
            <Box ref={tableContainerRef}>
              {pesquisarProcessos.data.data.map((i: any, index: number) => {
                let labelInfo = generateLabelInfo(i.fluxo.identificador, i.extras);
                return (
                  <Box
                    key={index}
                    m={2}
                    p={2}
                    borderRadius={3}
                    border="1px solid #CCC"
                    onClick={() => {
                      onClickDetalheProcesso(i.codigo);
                    }}
                    sx={{
                      cursor: "pointer",
                      ...(i.codigo === codigoPreenchido && {
                        animation: `${changeColorAnimation} 3.2s forwards reverse`,
                      }),
                    }}
                  >
                    <div>
                      <Link>
                        <HighlightedText text={`#${i.codigo}`} />
                      </Link>
                      <HighlightedText text={` - ${i.titulo}`} />
                    </div>
                    <Typography component="div" variant="caption">
                      <HighlightedText text={`${labelInfo}`} />
                    </Typography>
                    <Typography component="div" variant="caption">
                      <HighlightedText text={`Solicitado por ${i.usuario}`} />
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </InfiniteScroll>


        }
      </Box>
    </Box>
  );
}

interface FeitaProps {
  keyword: string;
  filtros: TFiltrosTarefas | null
  codigoPreenchido: string | null;
  onClickDetalheProcesso: (codigo: string) => void;
}
